import React from 'react';
import ReactSVG from 'react-svg';

import iconFile from 'appSrc/v5/assets/logos/logo-small.svg';

const SmallLogo = ( props ) => {
    const className = `icon-wrapper ${ props.className || '' }`.trim();

    return (
        <ReactSVG src={ iconFile }
        wrapper='div'
        { ...props }
        className={ className } />
    );
};
SmallLogo.defaultProps = {
    className: '',
};

export default SmallLogo;
